import { t } from 'i18next';
import { Icon } from '../icon/icon.spark';
import type { NavigationLinkProps } from './types';

export function NavigationLink({ onClick, children }: NavigationLinkProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="inline-flex items-center gap-1 font-medium text-spark-purple hover:brightness-125"
    >
      {children}
      <span className="sr-only">{t('aria:opens_new_tab')}</span>
      <Icon name="externalLink" />
    </button>
  );
}
